import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '400px',
    borderRadius: 5,
    height: 40,
    [theme.breakpoints.down('sm')]: {
      width: '200px'
    },
    border: `1px solid ${theme.palette.secondary.main}`
  },
  input: {
    paddingLeft: 10,
    width: '100%'
  },
  iconButton: {
    padding: 10
  },
  list: {
    fontSize: '0.6rem',
    width: '400px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '200px'
    }
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    paddingTop: 8,
    color: 'white',
    borderRadius: 5,
    '&:hover': { backgroundColor: theme.palette.secondary.main, cursor: 'pointer', opacity: 0.5 }
  },
  buttonFilter: {
    paddingTop: 0,
    borderRadius: 5,
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent !important' }
  }
}))
